// brandMappings.ts
import type { CountryMapping, LanguageMappings } from '@/interfaces/helpers/ILanguage'

export const defaultDK: CountryMapping = {
  country: 'dk',
  locale: 'da-DK',
  locales: ['da-DK', 'da', 'Dansk', 'dk', 'Denmark'],
  language: { fullName: 'Dansk', shortName: 'da' },
  flag: 'denmark',
  urls: [],
  envUrlKey: '',
  mapInformation: {
    city: 'København',
    zipCode: '1113',
    latitude: 55.68,
    longitude: 12.58,
    radius: 50
  }
}

export const defaultGB: CountryMapping = {
  country: 'gb',
  locale: 'en-US',
  locales: ['en-US', 'en', 'Engelsk', 'English', 'gb'],
  language: { fullName: 'English', shortName: 'en' },
  flag: 'britain',
  urls: [],
  envUrlKey: '',
  mapInformation: {
    city: 'London',
    zipCode: 'SE1 7PB',
    latitude: 51.5,
    longitude: 0.11,
    radius: 50
  }
}

export const defaultSE: CountryMapping = {
  country: 'se',
  locale: 'sv-SE',
  locales: ['sv-SE', 'SE', 'Svensk', 'Svenska', 'Sweden', 'sv'],
  language: { fullName: 'Svenska', shortName: 'sv' },
  flag: 'sweden',
  urls: [],
  envUrlKey: '',
  mapInformation: {
    city: 'Stockholm',
    zipCode: '11665',
    latitude: 59.31,
    longitude: 18.08,
    radius: 50
  }
}

export const defaultNO: CountryMapping = {
  country: 'no',
  locale: 'nb-NO',
  locales: ['nb-NO', 'no', 'Norsk', 'Norway', 'nb'],
  language: {
    fullName: 'Norsk',
    shortName: 'nb',
    secondaryfullName: 'nn',
    secondaryshortName: 'Nynorsk'
  },
  flag: 'norway',
  urls: [],
  envUrlKey: '',
  mapInformation: {
    city: 'Oslo',
    zipCode: '0457',
    latitude: 59.93,
    longitude: 10.75,
    radius: 50
  }
}

export const defaultFI: CountryMapping = {
  country: 'fi',
  locale: 'fi-FI',
  locales: ['fi-FI', 'FI', 'Finnish', 'Finsk', 'Suomi', 'Finland', 'fi', 'suomalainen'],
  language: { fullName: 'Suomi', shortName: 'fi' },
  flag: 'finland',
  urls: [],
  envUrlKey: '',
  mapInformation: {
    city: 'Helsinki',
    zipCode: '00260',
    latitude: 60.18,
    longitude: 24.93,
    radius: 50
  }
}

export const languageMappings: LanguageMappings[] = [
  {
    brand: 'a2b',
    countries: [
      {
        ...defaultDK,
        urls: [
          { environment: 'prod', url: 'portal.a2b.dk' },
          { environment: 'prod', url: 'eid.a2b.dk' },
          { environment: 'local', url: 'a2b-portal.localhost.dk' },
          { environment: 'qa', url: 'qa-portal.a2b.dk' },
          { environment: 'qa', url: 'qa-eid.a2b.dk' },
          { environment: 'dev', url: 'dev-portal.a2b.dk' }
        ],
        envUrlKey: 'VITE_API_URL_A2B_DK'
      },
      {
        ...defaultGB,
        urls: [
          { environment: 'prod', url: 'portal-en.a2b.dk' },
          { environment: 'prod', url: 'eid.a2b.dk' },
          { environment: 'qa', url: 'qa-portal-en.a2b.dk' },
          { environment: 'qa', url: 'qa-eid.a2b.dk' },
          { environment: 'dev', url: 'dev-portal-en.a2b.dk' },
          { environment: 'local', url: 'a2b-portal.localhost.dk' }
        ],
        envUrlKey: 'VITE_API_URL_A2B_EN'
      }
    ]
  },
  {
    brand: 'dep',
    countries: [
      {
        ...defaultDK,
        urls: [
          { environment: 'local', url: 'dep.localhost.dk' },
          { environment: 'prod', url: 'portal.danskerhvervspsykologi.dk' },
          { environment: 'qa', url: 'qa-portal.danskerhvervspsykologi.dk' },
          { environment: 'qa', url: 'qa-eid.as3.dk' },
          { environment: 'prod', url: 'eid.as3.dk' }
        ],
        envUrlKey: 'VITE_API_URL_DEP_DK'
      },
      {
        ...defaultGB,
        urls: [
          { environment: 'local', url: 'dep-portal.localhost.com' },
          { environment: 'prod', url: 'portal-en.danskerhvervspsykologi.dk' },
          { environment: 'qa', url: 'qa-portal-en.danskerhvervspsykologi.dk' },
          { environment: 'qa', url: 'qa-eid.as3.dk' },
          { environment: 'prod', url: 'eid.as3.dk' }
        ],
        envUrlKey: 'VITE_API_URL_DEP_EN'
      }
    ]
  },
  {
    brand: 'as3',
    countries: [
      {
        ...defaultDK,
        urls: [
          { environment: 'prod', url: 'portal.as3.dk' },
          { environment: 'prod', url: 'eid.as3.dk' },
          { environment: 'qa', url: 'qa-portal.as3.dk' },
          { environment: 'qa', url: 'qa-eid.as3.dk' },
          { environment: 'dev', url: 'dev-portal.as3.dk' },
          { environment: 'local', url: 'as3-portal.localhost.dk' }
        ],
        envUrlKey: 'VITE_API_URL_DK'
      },
      {
        ...defaultGB,
        urls: [
          { environment: 'prod', url: 'portal.as3companies.com' },
          { environment: 'prod', url: 'eid.as3.dk' },
          { environment: 'qa', url: 'qa-portal.as3companies.com' },
          { environment: 'qa', url: 'qa-eid.as3.dk' },
          { environment: 'dev', url: 'dev-portal.as3companies.com' },
          { environment: 'local', url: 'as3-portal.localhost.com' }
        ],
        envUrlKey: 'VITE_API_URL_EN'
      },
      {
        ...defaultSE,
        urls: [
          { environment: 'prod', url: 'portal.as3.se' },
          { environment: 'qa', url: 'qa-portal.as3.se' },
          { environment: 'dev', url: 'dev-portal.as3.se' },
          { environment: 'local', url: 'as3-portal.localhost.se' }
        ],
        envUrlKey: 'VITE_API_URL_SE'
      },
      {
        ...defaultNO,
        urls: [
          { environment: 'prod', url: 'portal.as3.no' },
          { environment: 'qa', url: 'qa-portal.as3.no' },
          { environment: 'dev', url: 'dev-portal.as3.no' },
          { environment: 'local', url: 'as3-portal.localhost.no' }
        ],
        envUrlKey: 'VITE_API_URL_NO'
      },
      {
        ...defaultFI,
        urls: [
          { environment: 'prod', url: 'portal.as3.fi' },
          { environment: 'qa', url: 'qa-portal.as3.fi' },
          { environment: 'dev', url: 'dev-portal.as3.fi' },
          { environment: 'local', url: 'as3-portal.localhost.fi' }
        ],
        envUrlKey: 'VITE_API_URL_FI'
      }
    ]
  }
]
